import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/layouts/default.vue").then(m => m.default || m))
}